var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrow = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4797 0.500241C3.613 0.500241 3.7397 0.553541 3.833 0.646841L6.31301 3.12694C6.50634 3.32024 6.50634 3.64024 6.31301 3.83354C6.11967 4.02684 5.79968 4.02684 5.60634 3.83354L3.4797 1.70684L1.353 3.83354C1.1597 4.02684 0.8397 4.02684 0.6463 3.83354C0.453 3.64024 0.453 3.32024 0.6463 3.12694L3.1264 0.646841C3.2197 0.553541 3.353 0.500241 3.4797 0.500241Z",
    fill: "#818A98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48633 0.5C3.75973 0.5 3.98633 0.7267 3.98633 1V13C3.98633 13.2733 3.75973 13.5 3.48633 13.5C3.21303 13.5 2.98633 13.2733 2.98633 13V1C2.98633 0.7267 3.20633 0.5 3.48633 0.5Z",
    fill: "#818A98"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.d3b24d70.svg";
export { ForwardRef as ReactComponent };